// main.js

// import "lazysizes"; // For use with lazysizes_support config option

import Disclosure from "./scripts/utils/Disclosure.js";
import Dialog from "./scripts/utils/Dialog.js";
import Tabs from "./scripts/utils/Tabs.js";
import SiteBanner from "./scripts/components/SiteBanner.js";

import Timeline from "./scripts/components/Timeline.js";
import Related from "./scripts/components/Related.js";
import Media from "./scripts/components/Media.js";
import OnToday from "./scripts/components/OnToday.js";
import Support from "./scripts/components/Support.js";
import "./scripts/components/Campaign.js";
import People from "./scripts/components/People.js";
import Quotes from "./scripts/components/Quotes.js";
import Accordion from "./scripts/components/Accordion.js";
import Memberships from "./scripts/components/Memberships.js";
import Crossfader from "./scripts/components/Crossfader.js";
import Smartcrop from "./scripts/components/Smartcrop.js";
import Sticky from "./scripts/components/Sticky.js";
import FeaturedVideo from "./scripts/components/FeaturedVideo.js";
import CogCredits from "./scripts/components/CogCredits.js";
import CogBooking from "./scripts/components/CogBooking.js";
import LoadingIndicator from "./scripts/components/LoadingIndicator.js";
import SpektrixSession from "./scripts/components/SpektrixSession.js";
import SpektrixIframe from "./scripts/components/SpektrixIframe.js";
import SpektrixLogin from "./scripts/components/SpektrixLogin.js";
import SpektrixGreeting from "./scripts/components/SpektrixGreeting.js";
import InstanceDialog from "./scripts/components/InstanceDialog.js";
import SpektrixPreferences from "./scripts/components/SpektrixPreferences.js";
import BasketCount from "./scripts/components/BasketCount.js";

import ShuffleGrid from "./scripts/components/Shuffle.js";

import whatsOnListing from "./scripts/whats-on.js";
import blogListing from "./scripts/blog.js";

import MultiSelect from "./scripts/components/CogMultiSelect.js";
import MultiSelectItem from "./scripts/components/CogMultiSelectItem.js";

// @feature custom-seating-plan
// import SeatingPlan from "./scripts/components/SeatingPlan.js";

document.addEventListener("DOMContentLoaded", () => {
    const globalSession = new SpektrixSession();
    globalSession.init();
});

document.addEventListener("DOMContentLoaded", () => {
    const elements = document.querySelectorAll("[data-disclosure]");

    elements.forEach((element) => {
        new Disclosure(element);
        // console.log("Disclosure instantiated", element);
    });
});

document.addEventListener("DOMContentLoaded", () => {
    const accordionElements = document.querySelectorAll(".accordion");

    accordionElements.forEach((element) => {
        new Accordion(element);
    });
});
